import { Model } from "pinia-orm";

export default class Incertitude extends Model {
  static entity = "incertitudes";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      project: this.attr(null),
      description: this.string(""),
      category: this.string(""),
      createdAt: this.attr(""),
    };
  }
}
